export default "__VITE_ASSET__oUvvPU4X__"